import React from "react";
import { useTranslation } from "react-i18next";

export interface ColumnMetaItem {
  key: string;
  label: string;
}

interface Props {
  columns: ColumnMetaItem[];
  selectedKeys: string[];
  onChange: (_: string[]) => void;
}

/**
 * 검사결과 조회 - 표시/추출할 컬럼을 체크박스로 선택.
 * 선택 결과는 테이블 표시와 엑셀 다운로드(columns 파라미터)에 함께 적용된다.
 */
export function ColumnSelector({ columns, selectedKeys, onChange }: Props) {
  const { t } = useTranslation("dataSearch");

  const allKeys = columns.map((c) => c.key);
  const isAllChecked = selectedKeys.length === allKeys.length;

  const toggle = (key: string) => {
    if (selectedKeys.includes(key)) {
      onChange(selectedKeys.filter((k) => k !== key));
    } else {
      // 원래 컬럼 순서를 유지해서 반영
      onChange(allKeys.filter((k) => selectedKeys.includes(k) || k === key));
    }
  };

  const toggleAll = () => onChange(isAllChecked ? [] : [...allKeys]);

  return (
    <div
      style={{
        border: "1px solid #dedede",
        borderRadius: 4,
        padding: "12px 16px",
        marginBottom: 16,
        background: "#fafafa",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
        <strong>{t("columnSelector.title")}</strong>
        <label style={{ cursor: "pointer", fontSize: 13 }}>
          <input type="checkbox" checked={isAllChecked} onChange={toggleAll} /> {t("columnSelector.all")}
        </label>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 18px" }}>
        {columns.map((c) => (
          <label key={`col-sel-${c.key}`} style={{ cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" }}>
            <input type="checkbox" checked={selectedKeys.includes(c.key)} onChange={() => toggle(c.key)} /> {c.label}
          </label>
        ))}
      </div>
    </div>
  );
}
